module.exports = __webpack_public_path__ + "static/media/pholidoptera_fallax_014_APA.74ac7610.png";